import React from "react"
import CustomPageHeader from "../fragments/CustomPageHeader"
import FinanciersMenu from "./Menu"

export default function Financiers() {

  return (
    <div>
      <CustomPageHeader icon='underline' text='Financiers' />
      <FinanciersMenu />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Financiers/index.js